import React, {useContext} from 'react'
import { GlobalDataContext } from '../../context/context'
import { ButtonContent } from './boton/ButtonContent'

const VideoPromocional = ({ linkVideo, image, title, text }) => {
    const { rpdata } = useContext(GlobalDataContext);

    const getEmbedInfo = (link) => {
        if (!link) return null;

        // Normalize input to string
        const s = String(link).trim();

        // Vimeo: matches vimeo.com/123456 or player.vimeo.com/video/123456
        const vimeoMatch = s.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
        if (vimeoMatch) {
            const id = vimeoMatch[1];
            // Use player.vimeo.com embed URL. Muted is useful for autoplay.
            const src = `https://player.vimeo.com/video/${id}?autoplay=1&loop=1&muted=1&badge=0`;
            return { provider: 'vimeo', src };
        }

        // YouTube: handle youtu.be/ID, youtube.com/watch?v=ID, or just an ID
        const ytMatch = s.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)?([A-Za-z0-9_-]{6,})/i);
        if (ytMatch) {
            const id = ytMatch[1];
            const src = `https://www.youtube.com/embed/${id}?&autoplay=1&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=${id}`;
            return { provider: 'youtube', src };
        }

        return null;
    };

    const embed = getEmbedInfo(linkVideo);

    return (
        <div
            className='bgCountentVideo'
            style={{
                backgroundImage: `url("${image ? image : rpdata?.stock?.[0]}")`
            }}
        >
            <div className='countentVideoInfo '>
                <div className='info'>
                    <h3>{title}</h3>
                    <p>{text}</p>
                    <ButtonContent />
                </div>
                {embed ? (
                    <iframe
                        title="Promotional video"
                        className='w-[90%] h-[280px] md:h-[360px] md:w-[50%] lg:h-[460px] lg:w-[60%] mx-auto rounded-3xl relative top-[80px] md:top-[150px]'
                        id="videoPlayer"
                        type="text/html"
                        src={embed.src}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                ) : (
                    <div className="w-[90%] md:w-[50%] lg:w-[60%] mx-auto rounded-3xl relative top-[80px] md:top-[150px] bg-gray-800 text-white p-6">
                        <p>No video disponible</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default VideoPromocional


